/**
 * dates constants
 */
const SET_DATE = 'SET_HASH';
export default SET_DATE;
